module.exports = __webpack_public_path__ + "img/checked.1586ca11.svg";